import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENameActionTypes {
  SetName = 'NEW_REVIEW/NAME/SET',
}

type TSetNameTypes = ITypedReduxAction<ENameActionTypes.SetName, string>;

/**
 * Redux action, который записывает в store имя при заполнении нового отзыва
 * @param name string
 */
export const setName: (name: string) => TSetNameTypes = actionGenerator<ENameActionTypes.SetName, string>(
  ENameActionTypes.SetName,
);

export type TReviewName = TSetNameTypes;
